import { render, staticRenderFns } from "./saleTaxTemplate.vue?vue&type=template&id=2c334e12&scoped=true"
import script from "./saleTaxTemplate.vue?vue&type=script&lang=js"
export * from "./saleTaxTemplate.vue?vue&type=script&lang=js"
import style0 from "./saleTaxTemplate.vue?vue&type=style&index=0&id=2c334e12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c334e12",
  null
  
)

export default component.exports